import styled from 'styled-components';
import { Icon, Input } from '@perch-labs/shrike';

export const StyledInput = styled(Input).attrs({
  margin: { bottom: '24px', top: '24px' },
})`
  min-width: 108px;
  width: 108px;
`;

export const SearchIcon = styled(Icon)`
  position: absolute;
  top: 42px;
  right: 16px;
`;

export const InputContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;
